<template>
  <div class="popoverList">
    <div class="item" v-for="(item, index) in data.list" :key="index">
      <img
        :src="require('@/assets/img/toefl/' + item.img + '.png')"
        :alt="item.name"
        :width="item.width"
        :height="item.height"
      />
      <div class="right">
        <div class="title">{{ item.title }}</div>
        <p>{{ item.src }}</p>
        <div>
          <span class="tpo" @click="jump('tpo', index)">官方公开真题</span
          >
          <!-- <span class="undisclosed" @click="jump('inside', index)">{{
            bottonText
          }}</span> -->
          <span
            class="undisclosed"
            v-if="index != 1 && navindex > 1"
            @click="jump('outside', index)"
            >在考真题套题</span
          >
        </div>
      </div>
    </div>
    <div class="bottom tree3Bottom" v-if="data.bottom">
      {{ data.bottom
      }}<img
        src="@/assets/img/toefl/free.png"
        width="34px"
        height="22px"
        alt="free"
        v-if="navindex == 1 || navindex == 2"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "headPopover",
  data() {
    return {
      isShow: true,
      toeflModel: {
        paperType: "tpo",
        tabIndex: 0,
      },
    };
  },
  props: {
    navindex: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: {},
    },
  },

  computed: {
    bottonText: function () {
      let txt = "";
      switch (this.navindex) {
        case 1:
          txt = "在考真题套题";
          break;
        case 2:
          txt = "阅读真题";
          break;
        case 3:
          txt = "听力真题";
          break;
        case 4:
          txt = "口语真题";
          break;
        case 5:
          txt = "写作真题";
          break;
      }
      return txt;
    },
  },

  methods: {
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    jump(paperType, outType, index) {
      let pathName = "",
        basePath = "";
      switch (this.navindex) {
        case 1:
          pathName = "exam";
          break;
        case 2:
          pathName = "reading";
          break;
        case 3:
          pathName = "listening";
          break;
        case 4:
          pathName = "speaking";
          break;
        case 5:
          pathName = "writing";
          break;
      }
      if (paperType == 1) {
        basePath = "tpo";
      } else {
        basePath = "undisclosed";
      }
      if (this.navindex > 1) {
        if (paperType) this.toeflModel.paperType = paperType;
        //处理套题外的选项卡选中
        // if (this.toeflModel.outType == 2 && index == 2) {
        //   this.toeflModel.tabIndex = 1;
        // } else {
        this.toeflModel.outType = outType;
        this.toeflModel.tabIndex = index;
        // }

        this.$store.commit("toeflModel", this.toeflModel);
      }
      this.$router.push({ path: `/toefl/${basePath}/${pathName}` });
    },
  },
};
</script>
<style scoped>
.popoverList {
  min-height: 140px;
}
.popoverList .item {
  overflow: hidden;
  padding-top: 24px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f5f5;
}
.item img {
  position: absolute;
}
.popoverList .item .title {
  width: 200px;
  height: 19px;
  font-size: 20px;
  font-weight: 400;
  color: #384047;
  line-height: 20px;
}
.popoverList .item p {
  font-size: 12px;
  font-weight: 400;
  color: #7b8b8e;
  line-height: 48px;
}
.right .tpo {
  display: inline-block;
  width: 88px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 16px;
  text-align: center;
  cursor: pointer;
}

.right .undisclosed {
  display: inline-block;
  width: 88px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border: 1px solid #5fcf80;
  border-radius: 16px;
  text-align: center;
  margin-left: 20px;
  color: #5fcf80;
  cursor: pointer;
}
.tree3 {
  display: block;
  width: 88px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border: 1px solid #5fcf80;
  border-radius: 16px;
  text-align: center;
  margin-top: 10px;
  color: #5fcf80;
  cursor: pointer;
}

.popoverList .item .right {
  margin-left: 40px;
}

.popoverList .bottom {
  width: 100%;
  height: 56px;
  background: #384047;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 19px;
  color: #ffffff;
  line-height: 56px;
  font-size: 14px;
  box-sizing: border-box;
}
.tree3Bottom {
  bottom: -40px !important;
}
.popoverList .bottom img {
  display: inline-block;
  margin-left: 7px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/gre/dialog/headPopover.vue